import { DateOnly } from '@if/core/date'
import { EOperationStatus, EPaymentMethod } from '@src/types/constants'
import { CalendarSimulation } from '@src/types/loan/loan-simulation'

export const CanSpreadOverdueAmountOnDates = (
  originalSimulation: CalendarSimulation,
  paymentDates: DateOnly[],
  canBypassAcpLock = false,
): boolean => {
  if (paymentDates.length === 0) return false
  const minimumDate = originalSimulation.getNextValidActionDate(EPaymentMethod.PreAuthorizedPayment, canBypassAcpLock)

  return paymentDates.every((date) => {
    const operationInformation = originalSimulation.operationInformations.find(
      (oi) => oi.operation.effectiveDate.getTime() === date.getTime(),
    )
    if (operationInformation == null || operationInformation == undefined) return false
    if (!operationInformation.isCustomerPaymentOperation()) return false
    if (operationInformation.operation.effectiveDate < minimumDate) return false
    if (operationInformation.operation.operationStatusId !== EOperationStatus.Planned) return false
    return true
  })
}
